var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-sub-menu',{attrs:{"title":"子菜单"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_c('span',[_vm._v("劳动人事部")])]),_vm._v(" "),_vm._l((_vm.list),function(item,index){return [(!item.children)?_c('a-menu-item',{key:item.title},[_c('span',[_vm._v(_vm._s(item.title))])]):_c('tree-menus',{key:index,attrs:{"list":item.children}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117cc81a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/components/tree-menus.vue
// module id = null
// module chunks = 